/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InitialScanRequest
 */
export interface InitialScanRequest {
    /**
     * 
     */
    status?: string;
}

/**
 * Check if a given object implements the InitialScanRequest interface.
 */
export function instanceOfInitialScanRequest(value: object): value is InitialScanRequest {
    return true;
}

export function InitialScanRequestFromJSON(json: any): InitialScanRequest {
    return InitialScanRequestFromJSONTyped(json, false);
}

export function InitialScanRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitialScanRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function InitialScanRequestToJSON(json: any): InitialScanRequest {
    return InitialScanRequestToJSONTyped(json, false);
}

export function InitialScanRequestToJSONTyped(value?: InitialScanRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
    };
}

